export enum TeamsTrunkAssignmentState {
  AssignedTrunkIsNotATeamsTrunk = 'AssignedTrunkIsNotATeamsTrunk',
  AssignedToTeamsTrunk = 'AssignedToTeamsTrunk',
  AssignedToTeamsTrunkWithoutEnabledOptionalFeature = 'AssignedToTeamsTrunkWithoutEnabledOptionalFeature',
  Unassigned = 'Unassigned',
}
